import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '@env/environment';
import { UrlHelper } from '@helpers';
import { Company } from '@lighty';
import { StorageService, TranslateService, ExternalAppsService, EmitterService } from '@services';
import { CookieService } from 'ngx-cookie-service';

@Component({
    selector: 'msc-learn',
    templateUrl: './learn.component.html',
    styleUrls: ['./learn.component.scss'],
})

export class LearnComponent implements OnInit {
    public me: any;
    public company: Company;
    public access: any;
    public sidebar: any;
    public applications: any;
    public sidebarExpanded: boolean = false;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private storageService: StorageService,
        private translateService: TranslateService,
        private cookieService: CookieService,
        private externalAppsService: ExternalAppsService,
        private emitterService: EmitterService,
    ) { }

    ngOnInit(): void {
        // Depuración: Imprime los datos recibidos del route.snapshot.data
        console.log('Route Snapshot Data:', this.route.snapshot.data);

        this.me = this.storageService.get('me');
        this.company = this.storageService.get('company') || this.route.snapshot.data.company; // Asegura fallback
        this.access = this.storageService.set('access', this.route.snapshot.data.access);
        this.sidebar = this.storageService.set('sidebar', this.route.snapshot.data.sidebar);
        this.applications = this.storageService.set('applications', this.route.snapshot.data.applications);

        // Depuración: Imprime los datos después de asignarlos
        /* console.log('Company:', this.company);
        console.log('Access:', this.access);
        console.log('Sidebar:', this.sidebar);
        console.log('Applications:', this.applications); */

        this.translateService.setLang(this.me.language.code);
        this.externalAppsService.boot(this.me, this.company, this.access.roles, 'learn', this.applications);

        this.emitterService.set('theme.change', this.company.experience.colorTemplate);

        this.processFavicon();
        this.checkOnboarding();

        if (this.company.id == 2044) {
            setTimeout(() => {
                document.getElementById('chatbase-bubble-button').style.display = 'block';
            }, 1000);
        } else {
            document.getElementById('chatbase-bubble-button').style.display = 'none';
        }
    }

    toggleSidebar(): void {
        this.sidebarExpanded = !this.sidebarExpanded;
    }

    private checkOnboarding(): void {
        if (!this.access.permissions.companyAccessPlatform && this.router.url.indexOf('onboarding') === -1) {
            this.router.navigate(['onboarding'], { relativeTo: this.route });
        }
    }

    private processFavicon(): void {
        if (this.company.experience.url?.media) {
            this.emitterService.set('favicon.change', this.company.experience.url.media.pictureUrl);
        }
    }

    loadMoreEmit(): void {
        this.emitterService.loadMoreSection.emit(true);
    }
}